import 'element-scroll-polyfill';
import { debounce } from 'lodash';
import { action, computed, observable } from 'mobx';
import { queueScrollWith } from './scrollHelpers';
import { YearsData } from './YearsData';

export class YearData {
    @observable value: string;
    @observable element: HTMLElement;

    @observable isVisible: boolean;
    @observable isActive: boolean;
    @action setVisible = (value: boolean) => {
        this.isVisible = value;
    };

    @action setActive = debounce((value: boolean) => {
        this.isActive = value;
    }, 100);

    @action setRef = (value: HTMLElement) => {
        this.element = value;
    };

    constructor(private store: YearsData, year: string) {
        this.value = year;
    }

    @computed get text(): string {
        return this.value.toString();
    };

    scrollIntoView(): void {
        if (!this.element) return;

        const { offsetWidth, offsetLeft } = this.element;
        const { scrollElement } = this.store;
        queueScrollWith(scrollElement, () => scrollElement.scrollTo({
            behavior: 'smooth',
            left: offsetLeft + (offsetWidth / 2) - (scrollElement.offsetWidth / 2),
        }));
    }
}
